{
  "R": [0, 120, 237, 240],
  "G": [0, 28, 105, 249],
  "B": [4, 109, 37, 33],
  "A": [0, 56, 80, 88],
  "I": [0, 64, 192, 255]
}
